import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import ProgressDonut from '../ProgressDonut';

export const StatusIcon = ({
  staticProgressIcon,
  submitted,
  totalQuota,
  sideNav,
}) =>
  staticProgressIcon ? (
    <img
      alt="progress-circle"
      className={styles.progressCircle}
      src={staticProgressIcon}
    />
  ) : (
    <ProgressDonut
      completed={submitted}
      total={totalQuota}
      size={sideNav ? 16 : 32}
      strokeWidth={sideNav ? 2 : 3}
      fill={'black'}
    />
  );

StatusIcon.propTypes = {
  staticProgressIcon: PropTypes.any.isRequired,
  submitted: PropTypes.number.isRequired,
  totalQuota: PropTypes.number.isRequired,
  sideNav: PropTypes.bool,
};

export default enhance(StatusIcon);
